import React, { memo } from "react";
import { Route, Routes } from "react-router-dom";
import { routesName } from "core";
import { OperationalAccessList } from "./operationalAccess/operationalAccessList";
import { OprationalAccessDetail } from "./operationalAccess/oprationalAccessDetail";
import { CreateOperationalAccess } from "./operationalAccess/createoperationalAccess";
import { CreateMandantoryMembership, EditMandantoryMemberShip, MandantoryMembershipDetail, MandatoryMembershipList } from "./mandantoryMembership";
import { EditOprationalAccess } from "./operationalAccess";


const Access = memo(() => {
  return (
    <Routes>
      <Route path={routesName.OPRATIONALACCESSLIST} element={<OperationalAccessList />} />
      <Route path={routesName.OPRATIONALACCESSDETAIL} element={<OprationalAccessDetail />} />
      <Route path={routesName.EDITOPRATIONALACCESS} element={<EditOprationalAccess />} />
      <Route path={routesName.CREATEOPERATIONALACCESS} element={<CreateOperationalAccess />} />
      <Route path={routesName.MANDATORYMEMBERSHIPLIST} element={<MandatoryMembershipList />} />
      <Route path={routesName.MANDANTORYMEMBERSHIPDETAIL} element={<MandantoryMembershipDetail />} />
      <Route path={routesName.EDITMANDANTORYMEMBERSHIP} element={<EditMandantoryMemberShip />} />
      <Route path={routesName.CREATEMANDANTORYMEMBERSHIP} element={<CreateMandantoryMembership />} />
    </Routes>
  );
});

export { Access };
